import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Pencil } from "lucide-react";
import { prodApi, fmtKg, fmtEur, fmtDate, errMsg, METHODS, labelOf } from "./prodApi";
import { useProd } from "./ProdApp";
import { PButton, PTitle, PCard, Spinner, PToggle } from "./ProdUi";
import ProdResult from "./ProdResult";

export default function ProdRunDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useProd();
  const [run, setRun] = useState(null);
  const [method, setMethod] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => { prodApi.get(`/production/runs/${id}`).then((r) => { setRun(r.data); setMethod(r.data.method); setResult(r.data.result); }).catch((e) => { toast.error(errMsg(e)); navigate("/produzione/lavorazioni"); }); }, [id, navigate]);

  useEffect(() => {
    if (!run || !method || method === run.method) { if (run) setResult(run.result); return; }
    const real = Object.fromEntries(run.outputs.map((o) => [`${o.node_id}|${o.trim_level_id || ""}`, o.weight_kg]));
    prodApi.post("/production/simulate", { recipe: run.recipe_snapshot, input: run.input, method, price_overrides: run.price_overrides || {}, real_outputs: real }).then((r) => setResult(r.data)).catch(() => {});
  }, [method, run]);

  const remove = async () => {
    if (!window.confirm(`Eliminare la lavorazione ${run.number}?`)) return;
    try { await prodApi.delete(`/production/runs/${id}`); toast.success("Lavorazione eliminata"); navigate("/produzione/lavorazioni"); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!run) return <Spinner text="Caricamento lavorazione..." />;
  const i = run.input || {};
  return (
    <div className="space-y-5" data-testid="prod-run-detail">
      <PTitle kicker={`${run.number} · ${fmtDate(run.date)} · ${run.operator}`} title={run.recipe_name}
        right={<>
          <PButton onClick={() => navigate("/produzione/lavorazioni")} data-testid="prod-run-back">← Lavorazioni</PButton>
          <PButton variant="primary" onClick={() => navigate(`/produzione/resa-rapida?run=${run.id}`)} data-testid="prod-run-edit"><Pencil className="w-4 h-4" /> Modifica pesi</PButton>
          {user?.is_manager && <PButton variant="danger" onClick={remove} data-testid="prod-run-delete"><Trash2 className="w-4 h-4" /></PButton>}
        </>}>
        {run.input_node_name} {fmtKg(i.total_kg, 3)} kg · {i.pieces || 1} pz{i.price_per_kg ? ` · ${fmtEur(i.price_per_kg)}/kg` : " · prezzo non indicato"}{i.supplier_name ? ` · ${i.supplier_name}` : ""}{i.origin ? ` · ${i.origin}` : ""}{i.lot ? ` · lotto ${i.lot}` : ""} · ricetta v{run.recipe_version}
      </PTitle>
      {run.notes && <PCard className="text-sm text-slate-300">{run.notes}</PCard>}
      <PCard className="flex flex-col md:flex-row md:items-center gap-3">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400 md:w-64">Metodo di distribuzione costo <span className="block text-slate-500 normal-case tracking-normal font-normal">salvato: {labelOf(METHODS, run.method)}</span></p>
        <PToggle className="flex-1" options={METHODS} value={method} onChange={setMethod} testIdPrefix="prod-run-method" />
      </PCard>
      <ProdResult result={result} />
    </div>
  );
}
